import { Stack } from 'expo-router';
import React from 'react';

function ChangeEmailVerifyLayoutWeb() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default ChangeEmailVerifyLayoutWeb;
